import React from "react";
import PropTypes from "prop-types";

import Section from "../common/Section";
import Form from "../common/Form";

import WerkenOpgeleverdForm from "./parts/WerkenOpgeleverdForm";
import EnergetischDuurzaamForm from "./parts/EnergetischDuurzaamForm";
import StedenbouwkundigHaalbaarForm from "./parts/StedenbouwkundigHaalbaarForm";
import RechtOpLangdurigZakelijkRechtForm from "./parts/RechtOpLangdurigZakelijkRechtForm";

import aanvragersFormattedForDropdown from "../../selectors/aanvragersFormattedForDropdown";

const MinimaleEisenPerInfrastructuurForm = (props) => {
	const {
		minimaleEisen,
		langdurigZakelijkRechtTypes,
		stedenbouwkundigeBestemmingen,
		disabled,
		errors,
		fileTypes,
		documenten,
		onChange,
		onChangeDateNVT,
		onCopyMijlpalen,
		onCopyZakelijkRecht,
		onCopyDuurzaamheid,
		onCopyHaalbaarheid,
		onDropFiles,
		onDeleteFile,
		onSave,
		color,
		dossierType,
		fileSessionStarted,
		sjablonen,
		otherInfrastructuren,
		standVanZakenMER,
		validationMessageType
	} = props;

	const sharedProps = {
		disabled,
		onChange,
		errors,
		validationMessageType,
		minimaleEisen
	};

	function mapDropFiles(component) {
		return function (files) {
			onDropFiles(component, files);
		};
	}

	function mapDeleteFile(component) {
		return function (fileName) {
			onDeleteFile(component, fileName);
		};
	}

	function getFilesForDossierComponent(component) {
		if (documenten) {
			const folder = documenten.find(x => x.name === component);
			if (folder) return folder.files;
		}
		return [];
	}

	function hasFilesForDossierComponent(component) {
		if (documenten) {
			const files = documenten.find(x => x.name === component).files;
			if (files) {
				return files.length > 0 ? true : false;
			}
		}
		return false;
	}

	const aanvragers = minimaleEisen.aanvragers.length > 0 ? aanvragersFormattedForDropdown(minimaleEisen.aanvragers) : [];

	return (
		<Section title="Vul het antwoord op onderstaande vragen in" color={color} disabled={disabled}>
			<Form
				title={'Invulformulier minimale eisen "' + props.infrastructuur.display + '"'}
				name="minimaleEisenInfra"
				rightButtonLabel="Bewaar"
				onRightButtonClick={onSave}
				rightButtonDisabled={disabled}>

				<RechtOpLangdurigZakelijkRechtForm
					{...sharedProps}
					color={color}
					fileTypes={fileTypes}
					mapDeleteFile={mapDeleteFile}
					mapDropFiles={mapDropFiles}
					getFilesForDossierComponent={getFilesForDossierComponent}
					hasFilesForDossierComponent={hasFilesForDossierComponent}
					aanvragers={aanvragers}
					langdurigZakelijkRechtTypes={langdurigZakelijkRechtTypes}
					fileSessionStarted={fileSessionStarted}
					dossierType={dossierType}
					onChange={onChange}
					otherInfrastructuren={otherInfrastructuren}
					onCopyZakelijkRecht={onCopyZakelijkRecht}
				/>
			<StedenbouwkundigHaalbaarForm
				{...sharedProps}
				color={color}
				fileTypes={fileTypes}
				mapDeleteFile={mapDeleteFile}
				mapDropFiles={mapDropFiles}
				getFilesForDossierComponent={getFilesForDossierComponent}
				hasFilesForDossierComponent={hasFilesForDossierComponent}
				dossierType={dossierType}
				stedenbouwkundigeBestemmingen={stedenbouwkundigeBestemmingen}
				fileSessionStarted={fileSessionStarted}
				standVanZakenMER={standVanZakenMER}
				otherInfrastructuren={otherInfrastructuren}
				onCopyHaalbaarheid={onCopyHaalbaarheid}
			/>

				<WerkenOpgeleverdForm
					{...sharedProps}
					otherInfrastructuren={otherInfrastructuren}
					onChangeDateNVT={onChangeDateNVT}
					onCopyMijlpalen={onCopyMijlpalen}
				/>

				<EnergetischDuurzaamForm
					{...sharedProps}
					color={color}
					fileTypes={fileTypes}
					mapDeleteFile={mapDeleteFile}
					mapDropFiles={mapDropFiles}
					getFilesForDossierComponent={getFilesForDossierComponent}
					getsj={getFilesForDossierComponent}
					hasFilesForDossierComponent={hasFilesForDossierComponent}
					dossierType={dossierType}
					fileSessionStarted={fileSessionStarted}
					sjablonen={sjablonen}
					otherInfrastructuren={otherInfrastructuren}
					onCopyDuurzaamheid={onCopyDuurzaamheid}
				/>
			</Form>
		</Section>
	);
};

// ----------------------------------------------------------------------------
MinimaleEisenPerInfrastructuurForm.propTypes = {
	minimaleEisen: PropTypes.object,
	documenten: PropTypes.array,
	langdurigZakelijkRechtTypes: PropTypes.arrayOf(PropTypes.object),
	stedenbouwkundigeBestemmingen: PropTypes.arrayOf(PropTypes.object),
	dossierType: PropTypes.number.isRequired,
	infrastructuur: PropTypes.object,
	disabled: PropTypes.bool,
	fileTypes: PropTypes.object,
	errors: PropTypes.object,
	onChange: PropTypes.func.isRequired,
	onChangeDateNVT: PropTypes.func.isRequired,
	onCopyMijlpalen: PropTypes.func.isRequired,
	onCopyZakelijkRecht: PropTypes.func.isRequired,
	onCopyDuurzaamheid: PropTypes.func.isRequired,
	onCopyHaalbaarheid: PropTypes.func.isRequired,
	onDropFiles: PropTypes.func,
	onDeleteFile: PropTypes.func,
	onSave: PropTypes.func.isRequired,
	color: PropTypes.string.isRequired,
	fileSessionStarted: PropTypes.bool.isRequired,
	otherInfrastructuren: PropTypes.array.isRequired,
	sjablonen: PropTypes.array.isRequired,
	onCheckBoxChange: PropTypes.func,
	standVanZakenMER: PropTypes.array.isRequired,
	validationMessageType: PropTypes.string
};

export default MinimaleEisenPerInfrastructuurForm;
